import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { marginLeft } from 'styled-system';
import type { MarginLeftProps } from 'styled-system';

import { HeadlineH8 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import {
  FilterButton,
  filterButtonStyles,
} from '../../category-options-buttons/components/CategoryOptionsButtons';
import { ButtonHitArea, buttonHitAreaStyles } from './PromotedFilterChip';

const StyledFilterButton = styled(FilterButton)<MarginLeftProps>`
  ${marginLeft};
`;

const styledFilterButtonStyles: ComponentProps<typeof StyledFilterButton> = {
  ...filterButtonStyles,
  marginLeft: '-6px',
  mx: 'sp_0',
  height: '32px',
  iconColor: 'colors.sys.primary.icon.default',
};

interface PromotedFilterButtonProps {
  onClick: () => void;
  selectedFiltersCount: number;
}

export const PromotedFilterButton = ({
  onClick,
  selectedFiltersCount,
}: PromotedFilterButtonProps) => {
  const { t } = useLocalization();
  const hasFilters = selectedFiltersCount > 0;
  const filterLabel = t('h24_filter');

  return (
    <ButtonHitArea onClick={onClick} {...buttonHitAreaStyles}>
      <StyledFilterButton
        {...styledFilterButtonStyles}
        data-testid="filters-button"
        aria-label={filterLabel}
        hasFilters={hasFilters}
      >
        <HeadlineH8
          as="span"
          color={hasFilters ? 'sys.primary.text.default' : 'sys.neutral.text.default'}
        >
          {filterLabel}
          {hasFilters ? ` (${selectedFiltersCount})` : ''}
        </HeadlineH8>
      </StyledFilterButton>
    </ButtonHitArea>
  );
};
